// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1q4Br","title":"Header_title__1ohi4","side":"Header_side__e6Hp6"};